<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage">({{locale.required}})</span>
    </div>
    <vc-date-picker class="notranslate"
      v-model="value"
      mode="date"
      :masks="{input: dateFormat.toUpperCase()}"
      :value="null"
      :attributes="calendarAttr"
      :disabled-dates="disabledDates"
      :locale="ln"
      @popoverWillShow="setPopover(true)"
      @afterHide="setPopover">
      <template v-slot="{ inputValue, togglePopover }">
        <div
          :style="valueStyle"
          class="btnCalendar"
          @click="togglePopover()">
          <span class="dateLabel">{{inputValue || '-'}}</span>
      </div>
      </template>
    </vc-date-picker>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment/moment'
import regExp from '@/common/regExp'

export default {
  name: 'Calendar',
  props: [
    'id',
    'itemSetting',
    'lang',
    'locale',
    'storageData'
  ],
  computed: {
    ...mapGetters({
      submitData: 'submit/getSubmitData'
    }),
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    ln () {
      return this.$route.params.ln
    },
    value: {
      get () {
        const data = typeof (this.submitData.find(x => x.id === this.id)) === 'undefined' ? '' : this.submitData.find(x => x.id === this.id).value
        return moment(data).toDate()
      },
      set (value) {
        const passed = !this.itemSetting.action.isRequired ? null : value !== ''
        const data = {
          id: this.id,
          value: value.toISOString(),
          passed: passed
        }
        this.$store.commit('submit/setValue', data)
      }
    },
    passed () {
      return this.submitData && this.submitData.find(x => x.id === this.id)
        ? this.submitData.find(x => x.id === this.id).passed
        : null
    },
    dateFormat () {
      return this.$store.getters['common/getDateFormat']
    },
    guestUserInfo () {
      return this.$store.getters['guest/getGuestUserInfo']
    },
    disabledDates () {
      const weekday = this.itemSetting.action.dayOfWeek.filter(x => !x.available).map(x => x.weekday)
      const hasTerm = this.itemSetting.action.hasTerm
      const disabledDays = this.itemSetting.action.disabledDays.map(x => x.id)
      const allowedToday = this.itemSetting.action.allowedToday
      const allowedPast = this.itemSetting.action.allowedPast
      const allowedStay = this.itemSetting.action.allowedStay
      const today = moment() // today로 계산할 경우 moment() 계산이 아닌 today가 계속 변경되므로 쓰지말것
      const dateFrom = moment(this.itemSetting.action.dateFrom)
      const hasRangeDay = this.itemSetting.action.hasRangeDay
      const guestUserInfo = this.guestUserInfo
      const stayBefore = guestUserInfo && guestUserInfo.stayBefore
      const stayAfter = guestUserInfo && guestUserInfo.stayAfter
      const rangeDayNumber = Number(regExp.numberOnly(this.itemSetting.action.rangeDayNumber || 30))
      const rangeFrom = allowedPast // 과거 선택 가능?
        ? hasTerm // 과거 선택 가능 + 기간 설정
          ? dateFrom.add(-1, 'days')
          : null
        : hasTerm // 과거 선택 불가 + 기간 설정
          ? moment().isAfter(dateFrom, 'days') // 오늘 지남?
            ? moment().add(-1, 'days')
            : dateFrom.add(-1, 'days')
          : moment().add(-1, 'days')
      const rangeTo = moment(this.itemSetting.action.dateTo).add(1, 'days')
      let dates = [{ weekdays: weekday }]
      if (allowedStay && stayAfter && stayBefore) { // 투숙기간만
        dates.push({
          start: null,
          end: moment(stayAfter).add(-1, 'days').endOf('day').toISOString()
        })
        dates.push({
          start: moment(stayBefore).add(1, 'days').startOf('day').toISOString(),
          end: null
        })
      }
      if (!allowedPast || hasTerm) {
        dates.push({
          start: null,
          end: rangeFrom.toISOString()
        })
      }
      if (hasTerm) {
        dates.push({
          start: rangeTo.toISOString(),
          end: null
        })
      }
      if (hasRangeDay) {
        dates.push({
          start: moment().add(rangeDayNumber + 1, 'days').toISOString(),
          end: null
        })
      }
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      if (!allowedToday) {
        dates.push(new Date())
      }
      return dates
    }
  },
  data () {
    return {
      message: 'is required',
      calendarAttr: [
        {
          bar: 'orange',
          dates: new Date()
        }
      ]
    }
  },
  methods: {
    isoToDateObj (iso) {
      return moment(iso).toDate()
    },
    setPopover (isPopover) {
      this.$emit('setPopover', isPopover ? this.id : '')
    }
  }
}
</script>
